import * as React from "react";
import { singleton } from "logic/singleton";
const defaultValue = {
  showDropdownButton: true,
  showPresetsButton: true,
  showAddToQuickListButton: true
};
const TimeRangeInputSettingsContext = React.createContext(defaultValue);
export default singleton(
  "views.components.contexts.TimeRangeInputSettingsContext",
  () => TimeRangeInputSettingsContext
);
